module.exports = __webpack_public_path__ + "media/images/cbjj/logo-cbjj-c73e2a59c6a8070852c410e8dca80761.png";